module.exports = __webpack_public_path__ + "img/5-5.c019f688.png";